export const Paths = {
    home: '/',
    reg: '/reg',
    login: '/login',
    test: '/test',
    testPass: '/test/pass',
    admin: '/admin',
    adminSettings: '/admin/settings',
    adminPharmacies: '/admin/pharmacies',
    adminPharmaciesAdd: '/admin/pharmacies/add',
    adminPharmaciesById: '/admin/pharmacies/:phId',
    admintestPermit: '/admin/test_permit',
    adminResults: '/admin/results',
    adminResultsById: '/admin/results/:id',
    adminResultsRetake: '/admin/results-retake/:id',
    adminRetakeTestById: '/admin/retake-test/:id',
    adminUsers: '/admin/users',
    adminUsersByUserIdEdit: '/admin/users/:user_id/edit',
    adminUsersById: '/admin/users/:id',
    adminUsersByIdCategoryIdTestId: '/admin/users/:user_id/:category_id/:test_id',
    adminMas: '/admin/mas',
    adminMasAdd: '/admin/mas/add',
    adminMasByUserId: '/admin/mas/:user_id',
    adminMasMasIdPhAdd: '/admin/mas/:masId/ph/add',
    adminTestsCategory: '/admin/tests-category',
    adminAddTest: '/admin/add-test',
    adminCheckTests: '/admin/check_tests',
    adminEditTestTestId: '/admin/edit_test/:test_id',
    adminAddTestCategory: '/admin/add-test-category',
    adminReports: '/admin/reports',
    adminMasRegionPharmacy: '/admin/reports/mas-region-pharmacy',
    adminMasRegionPharmacyById: '/admin/reports/mas-region-pharmacy/:id',
  
} as const